const routes = {
  home: '/',
  signin: '/signin'
}

export default routes
